export function unique(value, index, self) {
  return self.indexOf(value) === index;
}

export function flatten(array) {
  return Array.prototype.concat.apply([], array);
}
